import type { SortDescriptor } from "@coval/ui"

import type { AgentRecord } from "@/types/api/agent"

import { formatAgentType } from "./agentTypeLabel"

export function sortAgents(
  agents: AgentRecord[],
  sort: SortDescriptor | null,
): AgentRecord[] {
  if (!sort) {
    return agents
  }
  const value = (agent: AgentRecord): string => {
    if (sort.columnId === "created_at") {
      return agent.attribution?.created_at ?? ""
    }
    if (sort.columnId === "last_updated_at") {
      return agent.attribution?.updated_at ?? ""
    }
    if (sort.columnId === "model_type") {
      return formatAgentType(agent.model_type || "")
    }
    const field = agent[sort.columnId as keyof AgentRecord]
    return typeof field === "string" ? field : ""
  }
  return agents.toSorted((a, b) => {
    const first = value(a)
    const second = value(b)
    const comparison = first < second ? -1 : first > second ? 1 : 0
    return sort.direction === "desc" ? -comparison : comparison
  })
}
